<template>
  <div>
    <div class="frame-box">


      <ul class="activity-list">
        <div class="skeleton">
          <van-skeleton title :row="2" :loading="state.skeletonLoading" />
        </div>
        <li v-for="(item, i) in state.activitylist" :key="i + '-activitylist'" @click="goNewsdetails(item.id)">

          <div class="box">
            <div class="titlebox">

              <p class="van-ellipsis">{{ item.post_title }}</p>
            </div>

            <div class="contentbox">
              <span class="tapv" :style="{color: getTagColor(item.titlelb)}">{{ item.titlelb }}</span>
              <span class="line"></span>
              <span class="timev">{{ item.post_date }}</span>
            </div>
          </div>

          <img src="../../../assets/topic/right.png" alt="">



        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  reactive,
  onMounted
} from "vue";
import {
  useRoute,
  useRouter
} from "vue-router";
import {
  activelists
} from "@/api/gameindex";
import {
  useStore
} from "vuex";
import {
  detect
} from "@/utils/device";
// 引入的轻提示
import { Toast } from "vant";
import { getQueryString } from "@/utils/location";

export default {
  name: "gamedetailsserver",
  setup() {
    const route = useRoute();
    const store = useStore();
    const router = useRouter();
    const state = reactive({
      activitylist: [],
      skeletonLoading: true,
      tagColor: "",
    });

    const getTagColor = (str)=>{
      
      if(str == '游戏活动'){
        return '#12cdb0'
      }
      if(str == '游戏攻略'){
        return '#ff9000'
      }
      if(str == '转游规则'){
        return '#b134eb'
      }
      if(str == '游戏下架'){
        return '#eb5834'
      }
      if(str == '常见问题'){
        return '#34a1eb'
      }
      return "#12cdb0"
    }
    // 区服列表
    const serverlist = () => {
      let type = "";
      if (detect() == "ios") {
        type = "ios";
      } else {
        type = "android";
      }

      // 有gid时就使用，没有时就默认
      // let Gid=route.query.gid?route.query.gid:7
      let Gid = getQueryString("gid") ? getQueryString("gid") : 7

      activelists({
        type: "ios",
        gid: Gid,
        // username:store.state.username,
        username: "phetu1m8q0"
      }).then((response) => {
        console.log(response.data)
        if (response.data.code == 1) {
          console.log(response.data.data)
          state.activitylist = response.data.data;
        } else {
          Toast(response.data.msg)
        }
        state.skeletonLoading = false;
      });
    };

    // 活动详情
    const goNewsdetails = (id) => {
      router.push({
        path: "/newpersonal-page/newsdetails",
        query: {
          id: id
        }
      });
    };

    onMounted(() => {
      serverlist();
    });

    const onClickLeft = () => {
      router.back();
    };
    return {
      state,
      onClickLeft,
      goNewsdetails,
      getTagColor
    };
  },
};
</script>

<style scoped="scoped" lang="less">
div {
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', miui, 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
}
.frame-box {
  position: relative;
  padding-bottom: 50px;
  background-color: #fff;
  min-height:100vh;
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 16px;

  .activity-list {
    li {
      display: flex;
      align-items: center;

      .box {

        flex: 1;
        padding-top: 30px;
        padding-bottom: 30px;
        border-bottom: 1px solid #f9f9f9;
        display: flex;
        flex-direction: column;

        p {
          color: #333;
          font-size: 28px;
          font-weight: bold;
          width: 100%;
          flex: 1;
        }

        .contentbox {
          display: flex;
          align-items: center;
          margin-top: 12px;
          .tapv {
            color: #12cdb0;
            font-size: 24px;

          }
          .line {
            height: 20px;
            width: 1px;
            background-color: #ccc;
            color: #ccc;
            margin-left: 12px;
            margin-right: 12px;
          }
          .timev {
            color: #999;
            font-size: 24px;
          }
        }
      }

      img {
        flex-shrink: 1;
        width: 8px;
      }


    }


  }
}
</style>